// Chart configuration constants
export const CHART_CONFIG = {
  AXIS_EXTENT_MULTIPLIER: 1.1, // Extends scale by 10% for legibility
  PRODUCT_SHARE_THRESHOLD: 0.01 / 100, // 0.01% threshold
  STROKE_WIDTH: 0.0,
  STROKE_OPACITY: 0.5,
  STROKE_COLOR: 'darkgrey',
} as const;

// Chart margins
export const CHART_MARGIN = {
  LEFT: 60,
  RIGHT: 20,
  TOP: 20,
  BOTTOM: 40,
  Y_AXIS_SELECTOR_WIDTH: 100,
} as const;

// Re-export enums from @atlas-int/data (canonical source)
import {
  YAxisScalingOption,
  OverTimeOrderingOption,
  OverTimeLayoutOption,
} from "@atlas-int/data/types";
export { YAxisScalingOption, OverTimeOrderingOption, OverTimeLayoutOption };

/** Display labels for Y-axis scaling options (decoupled from enum values) */
export const yAxisScalingLabels: Record<YAxisScalingOption, string> = {
  [YAxisScalingOption.Current]: 'Current',
  [YAxisScalingOption.Constant]: 'Constant (2024 USD)',
  [YAxisScalingOption.PerCapita]: 'Per Capita',
  [YAxisScalingOption.PerCapitaConstant]: 'Per Capita Constant (2024 USD)',
};

export enum TradeValueScaledByYAxisOption {
  Current = 'current',
  Constant = 'constant',
  PerCapita = 'perCapita',
  PerCapitaConstant = 'perCapitaConstant',
}

// Helper to determine scaled trade value selector
export const determineScaledTradeValueSelector = (
  input: YAxisScalingOption
): TradeValueScaledByYAxisOption => {
  const mapping: Record<YAxisScalingOption, TradeValueScaledByYAxisOption> = {
    [YAxisScalingOption.Current]: TradeValueScaledByYAxisOption.Current,
    [YAxisScalingOption.Constant]: TradeValueScaledByYAxisOption.Constant,
    [YAxisScalingOption.PerCapita]: TradeValueScaledByYAxisOption.PerCapita,
    [YAxisScalingOption.PerCapitaConstant]: TradeValueScaledByYAxisOption.PerCapitaConstant,
  };

  return mapping[input] || TradeValueScaledByYAxisOption.Current;
};
